import { t } from "i18next";
import { IUserLog } from "interface/user";
import { GrideDateFormatter } from "ui/Date";
import CellPopover from "ui/grid/DescriptionCell";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
// import CellPopover from "ui/CellPopover";

function UserLog({ data }: { data: IUserLog[] }) {
	const pageable = data.length > 50 ? true : false;

	return (
		<div style={{}}>
			<GridWithGroupPaging
				gridData={data}
				className=""
				filterable={false}
				pageable={pageable}
				serverFilter={false}
				hideVirtualScroll={pageable}
				// itemAboveHeight={170}

				gridColumns={[
					{
						field: "datestamp",
						title: t("Date"),
						width: "160px",
						headerClassName: "no-border",
						cells: {
							data: (props) => (
								<GrideDateFormatter
									date={props.dataItem.datestamp}
									formatType={"dd.MM.yyyy HH:mm:ss"}
								/>
							),
						},
					},

					{
						field: "userName",
						title: t("Name"),
						width: "200px",
						headerClassName: "no-border",
					},

					{
						field: "operation",
						title: t("Operation"),
						width: "200px",
						headerClassName: "no-border",
					},

					{
						field: "logMessage",
						title: t("Message"),
						headerClassName: "no-border",
						cells: { data: (props) => <CellPopover {...props} /> },
					},
				]}
			/>
		</div>
	);
}

export default UserLog;
